import Component from './Tabs';

export default Component;
